import AppleLogin from '@/components/AppleLogin';
import { useAuth } from '@/contexts/AuthContext';
import { openEnjoyApp } from '@/utils/appDetection';
import request from '@/utils/request';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import {
  BottomImage,
  CloseButton,
  Container,
  Copyright,
  EnjoyImage,
  EnjoySection,
  EnjoySubtitle,
  EnjoyTitle,
  Header,
  Logo,
  ModalAILabel,
  ModalBottomLogo,
  ModalContent,
  ModalImage,
  ModalOverlay,
  PlayButton,
  ResidentsAvatars,
  ResidentsSection,
  ResidentsSubtitle,
  ResidentsTitle,
  StatsContainer,
  StatsImage,
  StatsScore,
  StatsText,
  VenueItem,
  VenuesGrid,
  VenuesSection,
  VoteButton,
  VoteCard,
  VoteCardContainer,
  VoteCardHeart,
  VoteCardImage,
  VoteCardLabel,
  VoteCards,
  VoteCardVS,
  VoteResultProgress,
  VoteResultProgressBar,
  VoteResultSection,
  VoteResultTitle,
  VoteSection,
  VoteSubtitle,
  VoteTitle,
  VoteToast
} from './styles';

// Import venue images
import enjoyBottomLogo from '../../assets/icons/imgs/enjoy_bottom_logo.png';
import enjoyClose from '../../assets/icons/imgs/enjoy_close.png';
import enjoyVenues1 from '../../assets/icons/imgs/enjoy_venues1.png';
import enjoyVenues10 from '../../assets/icons/imgs/enjoy_venues10.png';
import enjoyVenues11 from '../../assets/icons/imgs/enjoy_venues11.png';
import enjoyVenues12 from '../../assets/icons/imgs/enjoy_venues12.png';
import enjoyVenues13 from '../../assets/icons/imgs/enjoy_venues13.png';
import enjoyVenues14 from '../../assets/icons/imgs/enjoy_venues14.png';
import enjoyVenues15 from '../../assets/icons/imgs/enjoy_venues15.png';
import enjoyVenues16 from '../../assets/icons/imgs/enjoy_venues16.png';
import enjoyVenues17 from '../../assets/icons/imgs/enjoy_venues17.png';
import enjoyVenues18 from '../../assets/icons/imgs/enjoy_venues18.png';
import enjoyVenues2 from '../../assets/icons/imgs/enjoy_venues2.png';
import enjoyVenues3 from '../../assets/icons/imgs/enjoy_venues3.png';
import enjoyVenues4 from '../../assets/icons/imgs/enjoy_venues4.png';
import enjoyVenues5 from '../../assets/icons/imgs/enjoy_venues5.png';
import enjoyVenues6 from '../../assets/icons/imgs/enjoy_venues6.png';
import enjoyVenues7 from '../../assets/icons/imgs/enjoy_venues7.png';
import enjoyVenues8 from '../../assets/icons/imgs/enjoy_venues8.png';
import enjoyVenues9 from '../../assets/icons/imgs/enjoy_venues9.png';

const Vote = () => {
  const navigate = useNavigate();
  const { user, isLoggedIn, login, logout, loading: authLoading } = useAuth();
  
  // 任务相关状态
  const [campaignTaskId, setCampaignTaskId] = useState(null);
  const [taskData, setTaskData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isRequesting, setIsRequesting] = useState(false); // 防止重复请求
  
  // 投票相关状态
  const [hasVoted, setHasVoted] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalImage, setModalImage] = useState('');
  const [modalCard, setModalCard] = useState('');
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showToast, setShowToast] = useState(false);

  // 获取URL参数中的campaignTaskId
  useEffect(() => {
    console.log('🚀 Vote组件useEffect开始执行');
    console.log('🌐 当前URL:', window.location.href);
    console.log('🔗 当前路径:', window.location.pathname);
    console.log('❓ 查询参数:', window.location.search);
    
    let taskId = null;
    
    // 方式1：从路径参数获取 /outfits/30089 (新格式)
    console.log('🔍 检查outfits路径匹配:', window.location.pathname);
    let pathMatch = window.location.pathname.match(/\/outfits\/(\d+)/);
    console.log('🔍 outfits路径匹配结果:', pathMatch);
    if (pathMatch) {
      taskId = pathMatch[1];
      console.log('✅ 从outfits路径参数找到任务ID:', taskId);
    } else {
      // 方式2：从路径参数获取 /campaignTaskId/30089 (旧格式，向后兼容)
      console.log('🔍 检查campaignTaskId路径匹配:', window.location.pathname);
      pathMatch = window.location.pathname.match(/\/campaignTaskId\/(\d+)/);
      console.log('🔍 campaignTaskId路径匹配结果:', pathMatch);
      if (pathMatch) {
        taskId = pathMatch[1];
        console.log('✅ 从campaignTaskId路径参数找到任务ID:', taskId);
      } else {
        // 方式3：从查询参数获取 ?campaignTaskId=30089 (向后兼容)
        console.log('🔍 检查查询参数:', window.location.search);
        const urlParams = new URLSearchParams(window.location.search);
        taskId = urlParams.get('campaignTaskId');
        console.log('🔍 查询参数匹配结果:', taskId);
        if (taskId) {
          console.log('✅ 从查询参数找到任务ID:', taskId);
        }
      }
    }
    
    console.log('🔍 检查URL参数:', { taskId, url: window.location.href });
    
    if (taskId) {
      console.log('✅ 找到任务ID:', taskId);
      setCampaignTaskId(taskId);
      // 存储到本地
      localStorage.setItem('campaignTaskId', taskId);
      fetchTaskDetail(taskId);
    } else {
      // 检查本地存储是否有任务ID
      const localTaskId = localStorage.getItem('campaignTaskId');
      console.log('🔍 检查本地存储的任务ID:', localTaskId);
      
      if (localTaskId) {
        console.log('✅ 使用本地存储的任务ID:', localTaskId);
        setCampaignTaskId(localTaskId);
        fetchTaskDetail(localTaskId);
      } else {
        console.log('❌ No task ID found');
        setError('Task ID not found. Please check if the link is correct.');
        setLoading(false);
      }
    }
  }, [window.location.pathname, window.location.search]); // 监听路径和查询参数变化

  // 添加全局错误处理，防止未捕获的错误导致页面重新加载
  useEffect(() => {
    const handleError = (event) => {
      console.error('🚨 全局错误:', event.error);
      event.preventDefault(); // 阻止默认的错误处理
    };

    const handleUnhandledRejection = (event) => {
      console.error('🚨 未处理的Promise拒绝:', event.reason);
      event.preventDefault(); // 阻止默认的错误处理
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);

  // 获取任务详情
  const fetchTaskDetail = async (taskId) => {
    // 防止重复请求
    if (isRequesting) {
      console.log('⚠️ 请求正在进行中，跳过重复请求');
      return;
    }
    
    try {
      setIsRequesting(true);
      setLoading(true);
      setError(null);
      
      console.log('📡 开始请求任务详情:', taskId);
      const response = await request.get(`campaignTask/getDetail?campaignTaskId=${taskId}`);
      
      console.log('📡 原始响应:', response);
      
      // 响应拦截器已经处理了数据结构，response就是data
      if (response && response.code === 0) {
        const taskInfo = response.data;
        setTaskData(taskInfo);
        setHasVoted(taskInfo.hasVote);
        
        console.log('✅ 任务详情获取成功:', taskInfo);
        
        // 检查是否需要自动投票
        if (!taskInfo.hasVote) {
          // 在自动投票前先校验是否已投给他人或活动已结束
          if (taskInfo.hasVotedOthers) {
            console.log('⚠️ 已投给其他人（自动投票拦截）');
            toast.error("You've already voted!");
            return;
          }
          if (taskInfo.hasDateEnd) {
            console.log('⚠️ 活动已结束（自动投票拦截）');
            toast.error('This event has ended.');
            return;
          }

          const localCampaignTaskId = localStorage.getItem('campaignTaskId');
          const localOutfitId = localStorage.getItem('outfitId');
          const localCompanionId = localStorage.getItem('companionId');
          
          console.log('🔍 检查本地存储:', { 
            localCampaignTaskId, 
            localOutfitId,
            localCompanionId,
            currentTaskId: taskId 
          });
          
          // 如果本地有存储的投票数据且任务ID匹配，自动投票
          if (localCampaignTaskId && localOutfitId && localCampaignTaskId === taskId.toString()) {
            console.log('🚀 发现本地投票数据，自动执行投票');
            setTimeout(() => {
              // 尝试传入本地 companionId（如果存在）
              if (localCompanionId) {
                executeVote(parseInt(localOutfitId), parseInt(localCompanionId));
              } else {
                executeVote(parseInt(localOutfitId));
              }
            }, 1000); // 延迟1秒执行，确保UI更新完成
          }
        }
      } else {
        console.error('❌ 任务详情响应错误:', response);
        setError('Failed to fetch task details');
      }
    } catch (err) {
      console.error('❌ 获取任务详情失败:', err);
      
      // 根据错误类型设置不同的错误信息
      if (err.response) {
        const status = err.response.status;
        if (status === 404) {
          // 跳转到404页面
          navigate('/404');
          return;
        } else if (status === 500) {
          // 服务器错误也跳转到404页面
          navigate('/404');
          return;
        } else {
          setError(`Request failed (${status})`);
        }
      } else if (err.code === 'ECONNABORTED') {
        setError('Request timeout');
      } else {
        setError('Network connection failed');
      }
    } finally {
      setLoading(false);
      setIsRequesting(false);
    }
  };

  const handleVote = async (outfitId, companionId) => {
    if (hasVoted) return;
    
    // 检查是否已经投票给其他人
    if (taskData && taskData.hasVotedOthers) {
      console.log('⚠️ 用户已经投票给其他人');
      toast.error('You\'ve already voted!');
      return;
    }
    
    // 检查活动是否已结束
    if (taskData && taskData.hasDateEnd) {
      console.log('⚠️ 活动已结束');
      toast.error('This event has ended.');
      return;
    }
    
    // 存储outfitId到本地
    localStorage.setItem('outfitId', outfitId.toString());
    console.log('💾 存储outfitId到本地:', outfitId);
    // 存储companionId到本地
    if (companionId) {
      localStorage.setItem('companionId', companionId.toString());
      console.log('💾 存储companionId到本地:', companionId);
    }
    
    // 检查本地是否有cookie（jwtToken）
    const cookies = document.cookie.split(';');
    let jwtToken = null;
    
    for (let cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === 'jwtToken') {
        jwtToken = value;
        break;
      }
    }
    
    console.log('🍪 检查本地cookie:', { jwtToken: jwtToken ? '存在' : '不存在' });
    
    // 如果本地有cookie，直接调用投票接口
    if (jwtToken) {
      console.log('✅ 发现本地jwtToken，直接执行投票');
      await executeVote(outfitId, companionId);
      return;
    }
    
    // 检查用户是否已登录（localStorage中的token）
    if (!isLoggedIn) {
      setModalCard(outfitId); // 保存要投票的选项
      setShowLoginModal(true);
      return;
    }
    
    await executeVote(outfitId, companionId);
  };

  const executeVote = async (outfitId, companionIdParam) => {
    setSelectedCard(outfitId);
    setHasVoted(true);
    
    try {
      // 确保campaignTaskId有值，优先使用本地存储
      const currentTaskId = campaignTaskId || localStorage.getItem('campaignTaskId');
      // companionId 优先使用参数，其次本地存储，最后从taskData里根据outfitId匹配
      let currentCompanionId = companionIdParam || localStorage.getItem('companionId');
      if (!currentCompanionId && taskData?.voteOutfitInfo?.length) {
        const matched = taskData.voteOutfitInfo.find(item => item.outfitId === parseInt(outfitId));
        if (matched?.companionId) currentCompanionId = matched.companionId;
      }
      console.log('🗳️ 开始投票:', { 
        campaignTaskId: currentTaskId, 
        outfitId,
        companionId: currentCompanionId,
        fromState: campaignTaskId,
        fromLocalStorage: localStorage.getItem('campaignTaskId')
      });
      
      // 提交投票到服务器
      const voteData = {
        campaignTaskId: parseInt(currentTaskId),
        outfitId: parseInt(outfitId),
        companionId: currentCompanionId ? parseInt(currentCompanionId) : undefined
      };
      
      console.log('📤 发送投票请求:', voteData);
      const response = await request.post('/campaignTask/vote', voteData);
      
      console.log('📥 投票响应:', response);
      
      if (response && response.code === 0 && response.data === true) {
        console.log('✅ 投票成功，重新获取任务详情');
        // 清理本地存储的投票数据
        localStorage.removeItem('outfitId');
        localStorage.removeItem('companionId');
        console.log('🧹 清理本地投票数据 (outfitId, companionId)');
        // 清空本次点击的选中态，避免与hasVoted后的高亮叠加
        setSelectedCard(null);
        // 重新获取任务详情以更新投票数据
        await fetchTaskDetail(currentTaskId);
        // 显示自定义toast
        setShowToast(true);
        setTimeout(() => {
          setShowToast(false);
        }, 2000);
      } else {
        console.error('❌ 投票失败:', response);
        toast.error('Vote failed');
        setHasVoted(false);
        setSelectedCard(null);
      }
    } catch (error) {
      console.error('❌ 投票异常:', error);
      
      // 根据错误类型显示不同的错误信息
      if (error.response) {
        const status = error.response.status;
        if (status === 401) {
          toast.error('Please login first');
        } else if (status === 403) {
          toast.error('No vote permission');
        } else if (status === 404) {
          toast.error('Vote task not found');
        } else {
          toast.error(`Vote failed (${status})`);
        }
      } else if (error.code === 'ECONNABORTED') {
        toast.error('Vote timeout, please try again');
      } else {
        toast.error('Network error, please try again');
      }
      
      setHasVoted(false);
      setSelectedCard(null);
    }
  };

  const handlePlayClick = () => {
    openEnjoyApp();
  };

  const handleCardClick = (outfitInfo) => {
    setModalCard(outfitInfo.outfitId);
    setModalImage(outfitInfo.imageUrl);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setModalImage('');
    setModalCard('');
  };

  const handleAppleLogin = async (authData) => {
    console.log('🔐 Received Apple login data:', authData);
    console.log('🔐 Auth data structure:', {
      authorization: authData.authorization,
      user: authData.user,
      provider: authData.provider
    });
    
    const result = await login(authData);
    console.log('🔐 Login result:', result);
    
    if (result.success) {
      toast.success('Successfully signed in with Apple ID!');
      setShowLoginModal(false);
      // 登录成功后自动执行投票
      if (modalCard) {
        console.log('🔐 Auto-executing vote for card:', modalCard);
        await executeVote(modalCard);
      }
    } else {
      toast.error('Failed to sign in: ' + result.error);
    }
  };

  const handleAppleLogout = () => {
    logout();
    toast('Signed out successfully');
  };

  const handleCloseLoginModal = () => {
    setShowLoginModal(false);
    setModalCard('');
  };

  // 加载状态
  if (loading) {
    return (
      <Container>
        <div style={{ textAlign: 'center', padding: '50px', fontSize: '18px' }}>
          Loading...
        </div>
      </Container>
    );
  }

  // 错误状态
  if (error) {
    return (
      <Container>
        <div style={{ textAlign: 'center', padding: '50px', fontSize: '18px', color: 'red' }}>
          {error}
        </div>
      </Container>
    );
  }

  // 没有任务数据
  if (!taskData) {
    return (
      <Container>
        <div style={{ textAlign: 'center', padding: '50px', fontSize: '18px' }}>
          未找到任务数据
        </div>
      </Container>
    );
  }

  console.log('🎨 Vote组件开始渲染');
  
  return (
    <>
    <Container>
      <Header>
        <Logo>
          <div className="logo-icon"></div>
          <span>Enjoy - AI Town</span>
        </Logo>
        <PlayButton onClick={handlePlayClick}>PLAY</PlayButton>
      </Header>

      <VoteSection>
        <VoteTitle>Pick Your Side</VoteTitle>
        <VoteSubtitle>{taskData.title || 'Which outfit should I wear tonight?'}</VoteSubtitle>
        
        <VoteCards>
          <VoteCardVS hasVoted={hasVoted} />
          {taskData.voteOutfitInfo.map((outfit, index) => {
            const isSelected = selectedCard === outfit.outfitId;
            const isVotedOutfit = taskData.votedOutfitId === outfit.outfitId && taskData.voteCompanionId === outfit.companionId;
            return (
              <VoteCardContainer key={outfit.outfitId}>
                <VoteCard 
                  selected={isVotedOutfit || (!hasVoted && isSelected)}
                  disabled={hasVoted}
                  onClick={() => handleCardClick(outfit)}
                >
                  <VoteCardLabel selected={isVotedOutfit} hasVoted={hasVoted}>
                    {String.fromCharCode(65 + index)}
                  </VoteCardLabel>
                  <VoteCardImage imageUrl={outfit.imageUrl}>
                  </VoteCardImage>
                  <VoteCardHeart>❤️</VoteCardHeart>
                </VoteCard>
                
                {!hasVoted ? (
                  <VoteButton onClick={() => handleVote(outfit.outfitId, outfit.companionId)}>
                    VOTE
                  </VoteButton>
                ) : null}
              </VoteCardContainer>
            );
          })}
        </VoteCards>
        
        {/* 统一的投票结果进度条 */}
        {hasVoted && taskData.votedOutfitId && (
          <VoteResultSection>
            {(() => {
              const votedOutfit = taskData.voteOutfitInfo.find(outfit => outfit.outfitId === taskData.votedOutfitId);
              const votedPercentage = votedOutfit && taskData.totalVoteCount > 0 
                ? Math.round((votedOutfit.voteCount / taskData.totalVoteCount) * 100) 
                : 0;
              
              return (
                <>
                  <VoteResultTitle>❤️ {votedPercentage}% votes</VoteResultTitle>
                  <VoteResultProgress>
                    <VoteResultProgressBar percentage={votedPercentage} />
                  </VoteResultProgress>
                </>
              );
            })()}
          </VoteResultSection>
        )}

      </VoteSection>

      <EnjoySection>
        <EnjoyTitle />
        <EnjoySubtitle>Explore. Create. Grow.</EnjoySubtitle>
        <EnjoyImage />
        <StatsContainer>
          <StatsImage />
          <StatsText>Over 2M+ Players</StatsText>
          <StatsScore />
        </StatsContainer>
      </EnjoySection>

      <ResidentsSection>
        <ResidentsTitle>
          <div>1,150,000</div>
          <div>Residents</div>
        </ResidentsTitle>
        <ResidentsSubtitle>Meet Anyone You want</ResidentsSubtitle>
        <ResidentsAvatars />
      </ResidentsSection>

      <VenuesSection>
        <ResidentsTitle>
          <div>2,650,000</div>
          <div>Venues & Items</div>
        </ResidentsTitle>
        <ResidentsSubtitle>Create Your Own World</ResidentsSubtitle>
        <VenuesGrid>
          <VenueItem imageUrl={enjoyVenues1} />
          <VenueItem imageUrl={enjoyVenues2} />
          <VenueItem imageUrl={enjoyVenues3} />
          <VenueItem imageUrl={enjoyVenues4} />
          <VenueItem imageUrl={enjoyVenues5} />
          <VenueItem imageUrl={enjoyVenues6} />
          <VenueItem imageUrl={enjoyVenues7} />
          <VenueItem imageUrl={enjoyVenues8} />
          <VenueItem imageUrl={enjoyVenues9} />
          <VenueItem imageUrl={enjoyVenues10} />
          <VenueItem imageUrl={enjoyVenues11} />
          <VenueItem imageUrl={enjoyVenues12} />
          <VenueItem imageUrl={enjoyVenues13} />
          <VenueItem imageUrl={enjoyVenues14} />
          <VenueItem imageUrl={enjoyVenues15} />
          <VenueItem imageUrl={enjoyVenues16} />
          <VenueItem imageUrl={enjoyVenues17} />
          <VenueItem imageUrl={enjoyVenues18} />
        </VenuesGrid>
      </VenuesSection>

      <Copyright>© 2025-2026 Enjoy.ai. All rights reserved</Copyright>
    </Container>
    <BottomImage />
    
    {/* 弹框 */}
    {showModal && (
      <ModalOverlay onClick={handleCloseModal}>
        <CloseButton onClick={handleCloseModal} closeIcon={enjoyClose} />
        <ModalContent onClick={(e) => e.stopPropagation()}>
          <ModalImage imageUrl={modalImage}>
            {/* 备用内容，以防图片加载失败 */}
            <div style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              fontSize: '80px',
              zIndex: 5
            }}>
            </div>
            
            {/* 右下角Logo */}
            <ModalBottomLogo logoImage={enjoyBottomLogo} />
            
            {/* 左下角AI生成标识 */}
            <ModalAILabel>Generated with AI</ModalAILabel>
          </ModalImage>
        </ModalContent>
      </ModalOverlay>
    )}

    {/* 登录弹窗 */}
    {showLoginModal && (
      <ModalOverlay onClick={handleCloseLoginModal}>
        <CloseButton onClick={handleCloseLoginModal} closeIcon={enjoyClose} />
        <ModalContent onClick={(e) => e.stopPropagation()}>
          <div style={{
            padding: '24px 24px 32px 24px',
            textAlign: 'center',
            background: 'white',
            borderRadius: '20px',
            maxWidth: '400px',
            width: '90vw'
          }}>
            <h2 style={{ marginTop: '0', marginBottom: '12px', color: '#2B2928' }}>
              Sign in to Vote
            </h2>
            <p style={{ marginBottom: '24px', color: '#666' }}>
              Please sign in with Apple ID to cast your vote
            </p>
            <AppleLogin 
              onLogin={handleAppleLogin}
              onLogout={handleAppleLogout}
              user={user}
              loading={authLoading}
            />
          </div>
        </ModalContent>
      </ModalOverlay>
    )}
    
    {/* 投票成功Toast */}
    {showToast && (
      <VoteToast>Vote cast!</VoteToast>
    )}
    </>
  );
};

export default Vote;